<template>
    <div>
        <template v-if="item.type == '1' || item.type == '3' || item.type == '5'">
            <div class="package-data l1">
                <div class="package-charts svg_circle">
                    <div class="donut__svg__path">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" class="donut__svg">
                            <circle class="donut_svg_path path_1" :stroke="strokeColor"/>
                            <circle class="donut_svg_path path_2" :data-percent="item.value" :stroke="'url(#purple_' + item.matchId + ')'" strokeDasharray="200" strokeDashoffset="200" strokeLinecap="round" />
                            <defs>
                                <linearGradient :id="'purple_' + item.matchId" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0" :style="{stopColor:ColorSvg(item,'one')}"/>
                                    <stop offset="20%" :style="{stopColor:ColorSvg(item,'one')}"/>
                                    <stop offset="50%" :style="{stopColor:ColorSvg(item,'one')}"/>
                                    <stop offset="70%" :style="{stopColor:ColorSvg(item,'one')}"/>
                                    <stop offset="100%" :style="{stopColor:ColorSvg(item,'two')}"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="donut__svg__r"></div>
                    <span>{{item.value}}<cite>%</cite></span>
                </div>
                <div class="packages">{{item.str}}</div>
            </div>
        </template>
        <template v-else-if="item.cold">
            <div class="package-data l1">
                <div class="package-charts svg_circle">
                    <div class="donut__svg__path">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" class="donut__svg">
                            <circle class="donut_svg_path path_1" :stroke="strokeColor"/>
                            <circle class="donut_svg_path path_2" :data-percent="item.cold*1" :stroke="'url(#purple_' + item.schedule_id + ')'" strokeDasharray="200" strokeDashoffset="200" strokeLinecap="round" />
                            <defs>
                                <linearGradient :id="'purple_' + item.schedule_id" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="20%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="50%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="70%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="100%" :style="{stopColor:'#ff6f43'}"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="donut__svg__r"></div>
                    <span>{{item.cold*1}}<cite>%</cite></span>
                </div>
                <div class="packages">冷门指数</div>
            </div>
        </template>
        <template v-else-if="item.rec_value">
            <div class="package-data fullpre">
                <div class="package-charts svg_circle">
                    <div class="donut__svg__path">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" class="donut__svg">
                            <circle class="donut_svg_path path_1" :stroke="strokeColor"/>
                            <circle class="donut_svg_path path_2" :data-percent="item.rec_value * 1" :stroke="'url(#purple_' + item.schedule_id + ')'" strokeDasharray="200" strokeDashoffset="200" strokeLinecap="round" />
                            <defs>
                                <linearGradient :id="'purple_' + item.schedule_id" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="20%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="50%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="70%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="100%" :style="{stopColor:'#ff6f43'}"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="donut__svg__r"></div>
                    <span>{{item.rec_value*1}}<cite>%</cite></span>
                </div>
                <div v-if="item.rec_name == '胜'" class="packages">主胜概率</div>
                <div v-if="item.rec_name == '负'" class="packages">客胜概率</div>
                <div v-if="item.rec_name == '平'" class="packages">平局概率</div>
            </div>
        </template>
        <template v-else-if="item.home_stats">
            <div class="package-data fullpre">
                <div class="package-charts svg_circle">
                    <div class="donut__svg__path">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" class="donut__svg">
                            <circle class="donut_svg_path path_1" :stroke="strokeColor"/>
                            <circle class="donut_svg_path path_2" :data-percent="item.home_stats >= item.guest_stats ? item.home_stats : item.guest_stats" :stroke="'url(#purple_' + item.schedule_id + ')'" strokeDasharray="200" strokeDashoffset="200" strokeLinecap="round" />
                            <defs>
                                <linearGradient :id="'purple_' + item.schedule_id" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="20%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="50%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="70%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="100%" :style="{stopColor:'#ff6f43'}"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="donut__svg__r"></div>
                    <span>{{item.home_stats >= item.guest_stats ? item.home_stats : item.guest_stats}}<cite>%</cite></span>
                </div>
                <div class="packages">专家认可度</div>
            </div>
        </template>
        <template v-else-if="type == 21 && item.rec_bfb">
            <div class="package-data fullpre">
                <div class="package-charts svg_circle">
                    <div class="donut__svg__path">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" class="donut__svg">
                            <circle class="donut_svg_path path_1" :stroke="strokeColor"/>
                            <circle class="donut_svg_path path_2" :data-percent="Number(item.rec_bfb.substring(0,item.rec_bfb.lastIndexOf('%'))) * 1" :stroke="'url(#purple_' + item.schedule_id + ')'"  strokeDasharray="200" strokeDashoffset="200" strokeLinecap="round" />
                            <defs>
                                <linearGradient :id="'purple_' + item.schedule_id" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="20%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="50%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="70%" :style="{stopColor:'#ff0000'}"/>
                                    <stop offset="100%" :style="{stopColor:'#ff6f43'}"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div class="donut__svg__r"></div>
                    <span>{{Number(item.rec_bfb.substring(0,item.rec_bfb.lastIndexOf('%')))}}<cite>%</cite></span>
                </div>
                <div class="packages">{{item.rec_score}}球概率</div>
            </div>
        </template>
        <template v-else>
            <template v-if="item.type == '2'">
                <template v-if="item.type_string == 'shenglv'">
                    <div class="package-data">
                        <div class="package-charts svg_circle">
                            <div class="donut__svg__path">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" class="donut__svg">
                                    <circle class="donut_svg_path path_1" :stroke="strokeColor"/>
                                    <circle class="donut_svg_path path_2" :data-percent="item.value" :stroke="'url(#purple_' + item.matchId + ''" strokeDasharray="200" strokeDashoffset="200" strokeLinecap="round" />
                                    <defs>
                                        <linearGradient :id="'purple_' + item.matchId" x1="0%" y1="0%" x2="100%" y2="0%">
                                            <stop offset="0" :style="{stopColor:'#ff0000'}"/>
                                            <stop offset="20%" :style="{stopColor:'#ff0000'}"/>
                                            <stop offset="50%" :style="{stopColor:'#ff0000'}"/>
                                            <stop offset="70%" :style="{stopColor:'#ff0000'}"/>
                                            <stop offset="100%" :style="{stopColor:'#ff6f43'}"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                            <div class="donut__svg__r"></div>
                            <span>{{item.value}}<cite>%</cite></span>
                        </div>
                        <div class="packages">{{item.str}}</div>
                    </div>
                </template>
                <template plate v-else>
                    <div class="package-data">
                        <template v-for="(is,ins) in (item.value + '').split('!')">
                            <span :key="ins" class="packages-item">
                                <cite>{{is}}</cite>
                                <p>{{item.str.split("!")[ins]}}</p>
                            </span>
                        </template>
                    </div>
                </template>
            </template>
            <template v-else-if="item.type == '4'">
                <div class="package-data">
                    <template v-for="(is,ins) in (item.value + '').split('!')">
                        <span :key="ins" class="packages-item">
                            <cite>{{is}}</cite>
                            <p>{{item.str.split("!")[ins]}}</p>
                        </span>
                    </template>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "renderChar",
    props: ["item", 'isDark'],
    data () {
        return {
            strokeColor: this.isDark ? '#2f2f2f' : '#f2f2f2'
        }
    },
    methods: {
        ColorSvg (item, type) {
            // eslint-disable-next-line no-unused-vars
            let linearColor1 = "#ff0000";
            // eslint-disable-next-line no-unused-vars
            let linearColor2 = "#ff6f43";
            // 大热、同赔、庄家态度 图标形式
            // eslint-disable-next-line eqeqeq
            if (item.type == '1' || item.type == '3' || item.type == '5') {
                // 同赔需要判断胜平负，颜色区分
                // eslint-disable-next-line eqeqeq
                if (item.type == '3') {
                    // 客胜(小球)
                    // eslint-disable-next-line eqeqeq
                    if (item.win == '2') {
                        linearColor1 = "#7fb72f";
                        linearColor2 = "#b3c526";
                    // 走盘
                    // eslint-disable-next-line eqeqeq
                    } else if (item.win == '3') {
                        linearColor1 = "#1fbbe9";
                        linearColor2 = "#59d7fc";
                    }
                }
            }
            if (type === 'one') {
                return linearColor1
            } else {
                return linearColor2
            }
        }
    }
}
</script>
